import { render, staticRenderFns } from "./AssertionStep.vue?vue&type=template&id=43ae5c1f"
import script from "./AssertionStep.vue?vue&type=script&lang=js"
export * from "./AssertionStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports